import { handleError } from '@/utils/exception_handler';

import api from './api';

export default {

  // Uses FETCH mutations on TIMESHEETS
  fetchTimesheets: (context, args = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchTimesheets';

    commit(`${mutationPrefix}Pending`);

    return api.fetchTimesheets(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  fetchBMSReport: (context, args = {}) => {
    const { commit } = context;
    const mutationPrefix = 'fetchBMSReport';

    commit(`${mutationPrefix}Pending`);

    return api.fetchBMSReport(args)
      .then((response) => {
        commit(`${mutationPrefix}Success`, []);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses FETCH mutations on TIMESHEETS
  fetchSingleTimesheet: (context, args) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchSingleTimesheet';

    commit(`${mutationPrefix}Pending`);

    return api.fetchSingleTimesheet(args)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`, response.entity);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

    // Uses CREATE mutations on TIMESHEETS
  createTimesheet: (context, data) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'createTimesheet';

    commit(`${mutationPrefix}Pending`);

    return api.createTimesheet(data)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses UPDATE mutations on TIMESHEETS
  updateTimesheet: (context, requestParams) => {
    const { commit, dispatch } = context;
    const { id } = requestParams;
    const mutationPrefix = 'updateTimesheet';

    commit(`${mutationPrefix}Pending`, id);

    return api.updateTimesheet(requestParams)
      .then((response) => {
        dispatch('update', response.entity);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`), { id })
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  // Uses UPDATE mutations on TIMESHEETS
  changeStatus: (context, requestParams) => {
    const { commit, dispatch } = context;
    const { id } = requestParams;
    const mutationPrefix = 'changeStatus';

    commit(`${mutationPrefix}Pending`, id);

    return api.changeStatus(requestParams)
      .then((response) => {
        dispatch('update', response.entity);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`, { id }))
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  // Uses FETCH mutations on TIMESHEETS
  fetchRejectedTimesheets: (context, args = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchRejectedTimesheets';

    commit(`${mutationPrefix}Pending`);

    return api.fetchRejectedTimesheets(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses FETCH mutations on TIMESHEETS
  fetchPendingTimesheets: (context, args = {}) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'fetchPendingTimesheets';

    commit(`${mutationPrefix}Pending`);

    return api.fetchPendingTimesheets(args)
      .then((response) => {
        dispatch('insert', { data: response.entities });

        commit(`${mutationPrefix}Success`, response.entities);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/timesheet/actions.js